/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint no-underscore-dangle: 0 */
import {
  ClickAwayListener,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Avatar,
  Theme,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  List,
  Grid,
  Modal,
  Box,
  Tooltip,
  Drawer,
} from '@mui/material';
import QRCode from 'react-qr-code';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import React, {
  ReactNode,
  PropsWithChildren,
  useEffect,
  useRef,
  useState,
  useLayoutEffect,
} from 'react';
import { useDispatch } from 'react-redux';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { grey } from '@mui/material/colors';
import { MetaMaskButton } from '../../../app/new/container/components/metamask-button.component';
import { Shape } from '../../../assets/svg';
import { logout } from '../../../store/common/common.reducer';
import { premiumProfileChannel } from '../../../app/premium-profile/profile-path';
import styles from './layout.module.scss';
import { AuthService } from '../../services/auth/auth.service';
import ENVIRONMENTS, {
  getQuickcamCoinUrl,
} from '../../../environments';
import Notifications from '../notifications/notifications.component';
import { getProfileImageUrl } from '../../helpers/helpers';
import { useUserData } from '../../contexts/user-data.context';
import { UserPlaceholder, QuickieMemeIcons } from '../../../assets/images';
import Foundingicon from '../../../assets/images/Foundingmembers.png';
import Betaicon from '../../../assets/images/betaTester.png';
import Earlyicon from '../../../assets/images/Earlyadopters.png';
import QRCenterLogo from '../../../assets/images/QRCenterLogo.png';
import Defaultprofile from '../../../assets/images/DefaultProfile.png';
import DiscordIconDark from '../../../assets/images/discord.png';
import { store } from '../../../store/create-store';
import useMetaMask from '../../../hooks/useMetaMask';
import { DashboardBalanceCard, DashboardNavList } from '../dashboard-nav';
import QccHeaderMenu, {
  QccWalletButton,
} from '../qcc-balance/qcc-header-menu';
import { isQccBalancePreviewEnabled } from '../../constants/qcc-balance-mock';
import { userHasAdminAccess } from '../../dev/dev-admin-access';
import {
  readPreferences,
  toggleSidebarNavExpanded,
} from '../../preferences/dashboard-preferences';
import {
  HEADER_BTN_PREVIEW_EVENT,
  syncHeaderButtonPreviewDataset,
} from '../../../app/home/routes/dev/header-button-preview';
import { useLifetimeAccess } from '../../../app/creator-upgrades/hooks/useLifetimeAccess';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    profileImage: {
      width: 'clamp(40px, 10vw, 50px)', // Responsive image size
      height: 'clamp(40px, 10vw, 50px)',
      borderRadius: '50%',
      [theme.breakpoints.down('xs')]: {
        width: '35px', // Smaller for 320px
        height: '35px',
      },
    },
    qrprofileImage: {
      width: 'clamp(80px, 20vw, 100px)', // Responsive image size
      height: 'clamp(80px, 20vw, 100px)',
      borderRadius: '50%',
      [theme.breakpoints.down('xs')]: {
        width: '65px', // Smaller for 320px
        height: '65px',
      },
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalContent: {
      backgroundColor: 'var(--qc-shell-surface, #071426)',
      borderRadius: '20px', // Slightly larger radius for a modern look
      padding: '32px', // More padding for breathing room
      textAlign: 'center',
      outline: 'none',
      maxWidth: '90%',
      width: '420px', // Slightly wider modal
      position: 'relative',
      boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)', // Stronger shadow for depth
      border: 'none', // Remove border for a cleaner look
    },
    closeButton: {
      position: 'absolute',
      top: '-13px',
      right: '16px',
      cursor: 'pointer',
      color: 'var(--qc-shell-muted, #a9b5ca)', // Lighter color for a softer look
      fontSize: '28px', // Larger icon
      transition: 'color 0.2s ease', // Smooth hover transition
      '&:hover': {
        color: 'var(--qc-shell-copy, #f8f9ff)', // Darker on hover
      },
    },
    modalTitle: {
      fontSize: 'clamp(18px, 5vw, 20px)', // Responsive font size
      fontWeight: 700,
      margin: '0',
      color: 'var(--qc-shell-copy, #f8f9ff)',
      fontFamily: 'Roboto, sans-serif',
      [theme.breakpoints.down('xs')]: {
        fontSize: '16px', // Smaller font for 320px
      },
    },
    modalSubtitle: {
      fontSize: '24px', // Smaller for better hierarchy
      color: 'var(--qc-shell-copy, #f8f9ff)', // Softer color
      margin: '12px 0 20px 0', // Adjusted spacing
      paddingTop: '30px',
      fontWeight: 700,
      fontFamily: 'Roboto, sans-serif',
    },
    modalBadge: {
      marginBottom: '20px',
      width: '70px', // Slightly larger badge
      borderRadius: '50%', // Ensure circular shape
      border: '2px solid rgba(91, 151, 255, 0.22)', // Subtle border around badge
      transition: 'transform 0.3s ease', // Add subtle animation
      '&:hover': {
        transform: 'scale(1.05)', // Slight zoom on hover
      },
    },
    referralLinkContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: '20px',
      gap: '8px', // Space between link and copy button
    },
    referralLink: {
      fontSize: '16px',
      color: '#6638b6',
      wordBreak: 'break-all',
      fontWeight: 400,
    },
    copyButton: {
      backgroundColor: 'var(--qc-shell-surface-strong, #091a31)',
      border: 'none',
      borderRadius: '8px',
      padding: '6px 12px',
      cursor: 'pointer',
      fontSize: '12px',
      color: 'var(--qc-shell-copy, #f8f9ff)',
      fontWeight: 500,
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: 'var(--qc-shell-bg, #020712)',
      },
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'center', // Center the content horizontally
      alignItems: 'center',
      position: 'relative', // Keep relative for the close button positioning
      width: '100%', // Ensure it takes full width
      padding: '0 16px', // Add padding for smaller screens
    },
    modalHeaderIcon: {
      color: '#E5BABA',
      fontSize: 'clamp(20px, 5vw, 24px)', // Responsive icon size
      marginRight: '8px', // Space between icon and title
      [theme.breakpoints.down('xs')]: {
        fontSize: '18px', // Smaller icon for 320px screens
        marginRight: '5px', // Reduced spacing for small screens
      },
    },
    profileBadgeContainer: {
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      left: '50%', // Simplified to center horizontally
      top: '35%',
      [theme.breakpoints.down('xs')]: {
        top: '30%', // Adjusted for smaller screens
        left: '50%',
      },
    },
    qrCodeContainer: {
      border: '2px solid #B7B7B7',
      padding: '50px',
      paddingTop: '80px',
      paddingBottom: '40px',
      paddingLeft: '20px',
      paddingRight: '20px',
      boxSizing: 'border-box',
      marginTop: '80px',
      borderRadius: '20px',
      [theme.breakpoints.down('sm')]: {
        padding: '20px',
        paddingTop: '60px',
        paddingBottom: '20px',
        marginTop: '40px',
        borderRadius: '15px',
      },
    },
    walletAddress: {
      fontSize: '0.875rem',
      color: 'var(--qc-shell-muted, #a9b5ca)',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '200px',
    },
    profileMenuPaper: {
      minWidth: 220,
      marginTop: 8,
      overflow: 'hidden',
      border: '1px solid var(--qc-accent-line, rgba(91, 151, 255, 0.28))',
      borderRadius: 14,
      color: 'var(--qc-shell-copy, #f8f9ff)',
      background: 'var(--qc-shell-surface, #071426)',
      boxShadow: '0 22px 48px rgba(0, 0, 0, 0.45)',
    },
    profileMenuList: {
      padding: '8px',
      '& hr': {
        margin: '6px 8px',
        border: 0,
        borderTop: '1px solid rgba(91, 151, 255, 0.18)',
      },
      '& .MuiMenuItem-root': {
        minHeight: 42,
        margin: '2px 0',
        borderRadius: 10,
        color: 'var(--qc-shell-copy, #f8f9ff)',
        fontSize: 16,
        fontWeight: 600,
      },
    },
  }),
);

function Layout(
  props: PropsWithChildren<RouteComponentProps<ReactNode>>,
): JSX.Element {
  const classes = useStyles();

  const dispatch = useDispatch();

  const { user } = useUserData();
  const {
    status: lifetimeStatus,
    loading: lifetimeLoading,
    error: lifetimeError,
  } = useLifetimeAccess();
  const showUpgrade =
    !lifetimeLoading &&
    !lifetimeError &&
    Boolean(lifetimeStatus) &&
    lifetimeStatus?.lifetime_pass_type !== 'DUAL' &&
    !lifetimeStatus?.is_dual_member;
  const { children, history, location } = props;
  const { pathname } = location;
  const [open, setOpen] = useState(false);
  const [openPanel, setOpenPanel] = useState(false);
  const [openQRModal, setOpenQRModal] = useState(false);
  const [qccMenuAnchorEl, setQccMenuAnchorEl] =
    useState<HTMLElement | null>(null);
  const anchorRef = useRef<any>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [openDashboard, setOpenDashboard] = React.useState(false);
  const [openHelp, setOpenHelp] = React.useState(false);
  const [openCalculator, setOpenCalculator] = React.useState(false);
  const [windowSize, setWindowSize] = React.useState(0);
  const [openAdmin, setOpenAdmin] = React.useState(false);
  const { common } = store.getState();
  const { auth = {} } = common;
  const { token } = auth;
  const [copied, setCopied] = useState(false);
  const [openMemeCoin, setOpenMemeCoin] = React.useState(false);
  const [isMetaMaskBrowser, setIsMetaMaskBrowser] = useState(false);
  const quickieURL = ENVIRONMENTS.QUICKIE_BASE_URL;
  const [openCreatorUpgrades, setOpenCreatorUpgrades] = React.useState(false);
  const [openAdminUpgrades, setOpenAdminUpgrades] = React.useState(false);
  const [sidebarNavExpanded, setSidebarNavExpanded] = React.useState(
    () => readPreferences().sidebarNavExpanded,
  );
  const {
    account,
    connectWallet,
    disconnectWallet,
    isConnecting,
    isDisconnecting,
    isRestoring,
    walletStatus,
  } = useMetaMask();
  const qccFeatureEnabled = isQccBalancePreviewEnabled();

  const [currentTheme, setCurrentTheme] = useState(() =>
    document.documentElement.getAttribute('data-quickcam-theme') || 'dark',
  );

  useEffect(() => {
    syncHeaderButtonPreviewDataset();
    const onPreviewChange = () => syncHeaderButtonPreviewDataset();
    window.addEventListener(HEADER_BTN_PREVIEW_EVENT, onPreviewChange);
    return () =>
      window.removeEventListener(HEADER_BTN_PREVIEW_EVENT, onPreviewChange);
  }, []);

  useEffect(() => {
    if (!account) setQccMenuAnchorEl(null);
  }, [account]);

  useEffect(() => {
    const root = document.documentElement;
    const observer = new MutationObserver(() => {
      const theme = root.getAttribute('data-quickcam-theme') || 'dark';
      setCurrentTheme(theme);
    });
    observer.observe(root, { attributes: true, attributeFilter: ['data-quickcam-theme'] });
    return () => observer.disconnect();
  }, []);

  const isDashboardRoute = pathname.startsWith('/u');
  const showDesktopSidebarToggle =
    Boolean(user || auth?.token) && isDashboardRoute;

  const handleToggleSidebarNav = () => {
    const expanded = toggleSidebarNavExpanded();
    setSidebarNavExpanded(expanded);
  };

  const handleClickAdminUpgrades = () => {
    setOpenAdminUpgrades(!openAdminUpgrades);
  };
  useEffect(() => {
    const ua = navigator.userAgent || '';
    if (ua.includes('MetaMaskMobile')) {
      setIsMetaMaskBrowser(true);
    }
  }, []);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(referralLink)
      .then(() => {
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 1500); // Hide tooltip after 1.5 seconds
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  const handleClickMemeCoin = () => {
    if (!openMemeCoin) {
      setOpenDashboard(false);
      setOpenHelp(false);
      setOpenCalculator(false);
      setOpenAdmin(false);
    }
    setOpenMemeCoin(!openMemeCoin);
  };

  const handleClickCreatorUpgrades = () => {
    if (!openCreatorUpgrades) {
      setOpenDashboard(false);
      setOpenHelp(false);
      setOpenCalculator(false);
      setOpenAdmin(false);
      setOpenMemeCoin(false);
    }
    setOpenCreatorUpgrades(!openCreatorUpgrades);
  };

  console.log('user', user);
  const getVipInfo = (
    vipTier: string | undefined,
  ): { icon: string | null; badgeName: string | null } => {
    switch (vipTier) {
      case 'FOUNDING_MEMBER':
        return { icon: Foundingicon, badgeName: 'Founding Member' };
      case 'BETA_TESTER':
        return { icon: Betaicon, badgeName: 'Beta Tester' };
      case 'EARLY_ADOPTER':
        return { icon: Earlyicon, badgeName: 'Early Adopter' };
      case 'STANDARD':
      default:
        return { icon: null, badgeName: null }; // Hide for STANDARD or undefined
    }
  };

  const { icon: vipIconSrc, badgeName } = getVipInfo(user?.vipTier);

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
  };

  const handleClick = () => {
    setOpenDashboard(!openDashboard);
  };

  const handleClickCalculator = () => {
    setOpenCalculator(!openCalculator);
  };

  const handleClickHelp = () => {
    setOpenHelp(!openHelp);
  };

  const handleToggle = () => {
    setOpen((prevOpen: boolean) => !prevOpen);
  };

  const logoutHandle = async () => {
    const redirectUri = localStorage.getItem('redirect_uri');
    try {
      handleToggle();
      await disconnectWallet({ silent: true });
      await new AuthService().logout();
    } finally {
      localStorage.removeItem('refferingChannel');
      try {
        sessionStorage.removeItem('refferingChannel');
      } catch {
        /* ignore */
      }
      if (redirectUri?.endsWith('://app')) {
        window.location.href = redirectUri;
      } else {
        dispatch(logout());
      }
    }
  };

  const handleClose = (event: any) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setOpen(false);
  };

  const handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  };

  function closePanel() {
    setOpenPanel(false);
  }

  const handleClickAdmin = () => {
    if (!openAdmin) {
      setOpenDashboard(false);
      setOpenHelp(false);
      setOpenCalculator(false);
    }
    setOpenAdmin(!openAdmin);
  };

  const prevOpen = React.useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current?.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const performLogout = async (event: any) => {
    handleClose(event);
    try {
      await disconnectWallet({ silent: true });
      await new AuthService().logout();
    } finally {
      dispatch(logout());
    }
  };

  useLayoutEffect(() => {
    function updateSize() {
      setWindowSize(window.innerWidth);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const handleOpenQRModal = () => {
    history.push('/u/share');
  };

  const handleCloseQRModal = () => {
    setOpenQRModal(false);
  };

  const [handlePopUp, setHandlePopup] = useState(false);
  const handleBuyMemeCoins = () => {
    console.log('invoking handle buy meme coins');
    setHandlePopup(prev => !prev);
  };

  const referralLink =
    user?.referralPage || `${ENVIRONMENTS.QUICKIE_BASE_URL}/default`;
  // const QuickieMemeLink = `${process.env.REACT_APP_QUICKCAM_COIN_URL}?token=${token}`;

  const ensureTrailingSlash = (url: string) => {
    return url.endsWith('/') ? url : `${url}/`;
  };

  const getBaseUrl = () => {
    return getQuickcamCoinUrl();
  };

  const rawBaseUrl = getBaseUrl();
  const baseUrl = ensureTrailingSlash(rawBaseUrl);
  const QuickcamCoinUrl = `${baseUrl}?token=${token}`;

  return (
    <Grid className={styles.layout} container direction="column">
      <Grid item className={styles.header}>
        <IconButton
          className={[
            styles.iconContainer,
            openPanel ? styles.iconContainerOpen : '',
          ]
            .filter(Boolean)
            .join(' ')}
          onClick={() => setOpenPanel(open => !open)}
          size="large"
          aria-label={
            openPanel ? 'Close navigation menu' : 'Open navigation menu'
          }
          aria-expanded={openPanel}
        >
          <span className={`material-icons-outlined ${styles.mobileMenuIcon}`}>
            {openPanel ? 'close' : 'menu'}
          </span>
        </IconButton>
        <div className={styles.headerBrand}>
          {showDesktopSidebarToggle && (
            <IconButton
              className={styles.sidebarToggle}
              onClick={handleToggleSidebarNav}
              size="large"
              aria-label={
                sidebarNavExpanded
                  ? 'Collapse navigation menu'
                  : 'Expand navigation menu'
              }
              aria-expanded={sidebarNavExpanded}
              aria-controls="dashboard-sidebar-nav"
            >
              <span
                className={`material-icons-outlined ${styles.sidebarToggleIcon}`}
              >
                view_sidebar
              </span>
            </IconButton>
          )}
          <Link to="/">
            {/* <div className={styles.metamaskButton}>
            <MetaMaskButton />
          </div> */}
            <p className={styles.heading}>
              <img src={Shape} alt="QuickCam" width="36" />
              <span className={styles.headingText}>QuickCam</span>
            </p>
          </Link>
        </div>
        <button
          type="button"
          className={`${styles.qrButton} qc-header-share-btn`}
          onClick={handleOpenQRModal}
        >
          <span className="material-icons-outlined" aria-hidden>
            share
          </span>
          {windowSize > 768 && <span>Share</span>}
        </button>
        <a
          href="https://discord.gg/ZgqJXp3h5E"
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.discordButton} qc-header-discord-btn`}
          aria-label="Join our Discord server"
        >
          <img
            src={currentTheme === 'light' || currentTheme === 'moderate' ? DiscordIconDark : DiscordIconDark}
            alt="Discord Icon"
            className={styles.discordIcon}
          />
          {windowSize > 768 && <span>Join Discord Server</span>}
        </a>

        <div className={styles.actions}>
          <div className={styles.headerActionGroup}>
            {/* <div
              className={`${styles.vipIcon} ${!vipIconSrc || !badgeName ? styles.hidden : ''
                }`}
            >
              {badgeName && (
                <span
                  style={{
                    marginLeft: windowSize > 450 ? '18px' : '',
                  }}
                  className={styles.vipBadgeName}
                >
                  {badgeName}
                </span>
              )}
              {vipIconSrc && <img src={vipIconSrc} alt="VIP Icon" />}
            </div> */}
            {/* <div className={styles.quickieButtonContainer}>
              <button
                className={styles.quickieButton}
                type="button"
                onClick={() => {
                  if (windowSize > 768 || isMetaMaskBrowser) {
                    navigator.clipboard.writeText(QuickcamCoinUrl);
                    window.open(QuickcamCoinUrl, '_self');
                  }

                  else {
                    handleBuyMemeCoins()
                  }
                }}
              >
                {/* <img
                  src={QuickieMemeIcons}
                  alt="Quickie Icon"
                  style={{ width: '21px', height: '21px' }}
                />

                {windowSize > 768 && (
                  <span>Buy QuickCam Coin</span>
                )} *

              </button>
            </div> */}

            {handlePopUp && (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0,0,0,0.6)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '10px', // add padding for safe area
                  zIndex: 1000,
                }}
              >
                <div
                  style={{
                    backgroundColor: 'var(--qc-shell-surface, #071426)',
                    padding: '20px 15px',
                    borderRadius: 12,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                    width: '100%',
                    maxWidth: '360px',
                    textAlign: 'left',
                    fontSize: '16px',
                    lineHeight: 1.4,
                    fontFamily: 'Arial, sans-serif',
                    color: 'var(--qc-shell-copy, #f8f9ff)',
                    overflowY: 'auto',
                    maxHeight: '90vh',
                  }}
                >
                  <h2
                    className={classes.modalTitle}
                    style={{ textAlign: 'center', marginBottom: '15px' }}
                  >
                    Buy Quickies
                  </h2>
                  <p
                    style={{
                      lineHeight: 1.6,
                      wordSpacing: '2px',
                      marginBottom: '16px',
                    }}
                  >
                    MetaMask app must be installed to continue or use a
                    desktop/laptop computer web browser with MetaMask extension
                    installed.
                  </p>

                  <h3 style={{ margin: '15px 0 10px 0', fontWeight: 'bold' }}>
                    On Mobile:
                  </h3>
                  <ol className={styles.instructionList}>
                    <li>Install and open MetaMask app</li>
                    <li>
                      Go to the web browser tab and enter{' '}
                      <span className={styles.bold}>Quickiecoin.meme</span> in
                      the address bar.
                    </li>
                    <li>
                      Login with your username and password.{' '}
                      <span className={styles.bold}>
                        Do not use social login.
                      </span>
                    </li>
                    <li>Connect your wallet</li>
                    <li>Buy Quickie meme coins.</li>
                  </ol>
                  <div
                    style={{
                      textAlign: 'center',
                      marginTop: 20,
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <button
                      type="button"
                      className={styles.quickieButton}
                      style={{
                        width: '160px',
                        height: '45px',
                        marginRight: '25px',
                        padding: '20px',
                      }}
                      onClick={() => navigator.clipboard.writeText(quickieURL)}
                    >
                      Copy Link
                    </button>
                    <button
                      type="button"
                      className={styles.quickieButton}
                      style={{
                        width: '160px',
                        height: '45px',
                      }}
                      onClick={() => {
                        handleBuyMemeCoins();
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}

            {windowSize > 990 && (
              <div className={styles.metamaskButton}>
                {qccFeatureEnabled ? (
                  <QccWalletButton
                    account={account}
                    menuOpen={Boolean(qccMenuAnchorEl)}
                    status={walletStatus}
                    onConnect={() => connectWallet()}
                    onOpen={anchor => setQccMenuAnchorEl(anchor)}
                  />
                ) : (
                  <MetaMaskButton
                    account={account}
                    connectWallet={connectWallet}
                    disconnectWallet={disconnectWallet}
                  />
                )}
              </div>
            )}

            <Notifications />
            <Avatar
              className={`${classes.profileImage} ${styles.profileImage}${getProfileImageUrl(user?.profileImageURL || '')
                  ? ''
                  : ` ${styles.profileInitials}`
                }`}
              src={
                getProfileImageUrl(user?.profileImageURL || '') ||
                `${UserPlaceholder}`
              }
              onClick={handleToggle}
              ref={anchorRef}
            >
              {(
                `${user?.firstName?.charAt(0)}${user?.lastName?.charAt(0)}` ||
                user?.channelName?.charAt(0) ||
                ''
              ).toUpperCase()}
            </Avatar>
          </div>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...TransitionProps}
                unmountOnExit
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper className={classes.profileMenuPaper} elevation={0}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="account-list-grow"
                      className={`${classes.profileMenuList} ${styles.profileMenuList}`}
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem style={{ textTransform: 'none' }}>
                        @{user?.channelName}
                      </MenuItem>
                      <hr />
                      {showUpgrade && (
                        <MenuItem
                          onClick={() => {
                            history.push('/u/creator-upgrades/subscriptions');
                            setOpen(false);
                          }}
                        >
                          Upgrade
                        </MenuItem>
                      )}
                      <MenuItem
                        onClick={() => {
                          history.push('/u/settings');
                          setOpen(false);
                        }}
                      >
                        Edit Profile
                      </MenuItem>
                      <hr />
                      {qccFeatureEnabled && isRestoring && (
                        <MenuItem disabled>Checking Wallet…</MenuItem>
                      )}
                      {qccFeatureEnabled && !isRestoring && !account && (
                        <MenuItem
                          disabled={isConnecting}
                          onClick={() => {
                            connectWallet();
                            setOpen(false);
                          }}
                        >
                          {isConnecting ? 'Connecting…' : 'Connect Wallet'}
                        </MenuItem>
                      )}
                      {qccFeatureEnabled && (isRestoring || !account) && <hr />}
                      {!qccFeatureEnabled && !account && (
                        <MenuItem
                          onClick={() => {
                            connectWallet();
                            setOpen(false);
                          }}
                        >
                          Connect Wallet
                        </MenuItem>
                      )}
                      {!qccFeatureEnabled && !account && <hr />}
                      {!qccFeatureEnabled && account && (
                        <MenuItem
                          onClick={() => {
                            disconnectWallet();
                            setOpen(false);
                          }}
                        >
                          Disconnect Wallet
                        </MenuItem>
                      )}
                      {!qccFeatureEnabled && account && (
                        <MenuItem
                          style={{
                            textTransform: 'none',
                            pointerEvents: 'none',
                          }}
                        >
                          <span className={classes.walletAddress}>
                            {`${account.slice(0, 8)}...${account.slice(-7)}`}
                          </span>
                        </MenuItem>
                      )}
                      {!qccFeatureEnabled && account && <hr />}
                      <MenuItem onClick={logoutHandle}>Logout</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
          {qccFeatureEnabled && account && (
            <QccHeaderMenu
              account={account}
              anchorEl={qccMenuAnchorEl}
              isDisconnecting={isDisconnecting}
              onClose={() => setQccMenuAnchorEl(null)}
              onDisconnect={() => disconnectWallet()}
            />
          )}
        </div>
      </Grid>

      <Modal
        open={openQRModal}
        onClose={handleCloseQRModal}
        keepMounted={false}
        disableScrollLock
        className={classes.modal}
      >
        <Box className={classes.modalContent}>
          <Box className={classes.modalHeader}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span
                className={`material-icons-outlined ${classes.modalHeaderIcon}`}
              >
                qr_code
              </span>
              <h2 className={classes.modalTitle}>Your Referral Link</h2>
            </Box>
            <span className={classes.closeButton} onClick={handleCloseQRModal}>
              <span className="material-icons-outlined">close</span>
            </span>
          </Box>
          <p className={classes.modalSubtitle} style={{ marginTop: '20px' }}>
            Share Your Referral Link
          </p>
          <div className={classes.qrCodeContainer}>
            <div className={classes.profileBadgeContainer}>
              <img
                className={classes.qrprofileImage}
                src={
                  getProfileImageUrl(user?.profileImageURL || '') ||
                  Defaultprofile
                }
                alt="User Profile Badge"
              />
            </div>
            <QRCode
              value={referralLink}
              size={200}
              bgColor="var(--qc-shell-surface, #071426)"
              fgColor="#6638b6"
              level="H"
            />
            <img
              src={QRCenterLogo}
              alt="QR Center Logo"
              style={{
                position: 'absolute',
                top: '65%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 'clamp(30px, 8vw, 35px)', // Responsive logo size
                height: 'clamp(30px, 8vw, 35px)',
              }}
            />
          </div>
          <div className={classes.referralLinkContainer}>
            <p className={classes.referralLink}>{referralLink}</p>
            <Tooltip
              title="Your referral link was copied."
              open={copied}
              placement="top"
              disableFocusListener
              disableHoverListener
              disableTouchListener
              componentsProps={{
                tooltip: {
                  style: {
                    fontSize: '1rem',
                    backgroundColor: '#333',
                    padding: '8px 12px',
                  }, // Adjust as needed
                },
              }}
            >
              <button
                type="button"
                className={classes.copyButton}
                onClick={handleCopy}
                aria-label="Copy referral link"
              >
                Copy
              </button>
            </Tooltip>
          </div>
        </Box>
      </Modal>

      <Grid item xs={12}>
        {children}
      </Grid>
      <Drawer
        anchor="left"
        open={openPanel}
        onClose={() => closePanel()}
        PaperProps={{ className: styles.mobileNavDrawerPaper }}
        ModalProps={{
          BackdropProps: { className: styles.mobileNavBackdrop },
        }}
      >
        <div className={styles.sidePanelContainer}>
          <div className={styles.sidePanelHeader}>
            <Link
              to="/u/dashboard"
              className={styles.sidePanelHeading}
              onClick={() => {
                closePanel();
              }}
            >
              <img src={Shape} alt="QuickCam" width="50" />
              QuickCam
            </Link>
          </div>
          <DashboardBalanceCard onNavigate={() => closePanel()} />
          <div className={styles.sidePanelLinks}>
            <DashboardNavList
              variant="mobile"
              isAdmin={userHasAdminAccess(user?.roles)}
              onNavigate={() => closePanel()}
              onLogout={event => {
                closePanel();
                performLogout(event);
              }}
            />
          </div>
        </div>
      </Drawer>
      {!premiumProfileChannel(pathname) && (
      <section className={styles.footer} id="dashboard-footer">
        <span>
          <p>
            <Link to="/about-us">About us</Link>
          </p>
          <p>|</p>
          <p>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </p>
          <p>|</p>
          <p>
            <Link to="/cookie-policy">Cookie Policy</Link>
          </p>
          <p>|</p>
          <p>
            <Link to="/terms-and-conditions">Terms of Service</Link>
          </p>
          <p>|</p>
          <p>
            <Link to="/trust-policy">Trust Policy</Link>
          </p>
          <p className={styles.hidden}>|</p>
        </span>
        <p>&copy; Copyright 2026 QuickCam, LLC. All rights reserved.</p>
      </section>
      )}
    </Grid>
  );
}

export default withRouter(Layout);
